import * as Immutable from 'immutable';
import {
  LIST_NOTIFICATIONS_REQUESTED,
  LIST_NOTIFICATIONS_COMPLETED,
  LIST_NOTIFICATIONS_FAILED,
  RESET_LIST_NOTIFICATIONS_REQUESTED,
  RESET_LIST_NOTIFICATIONS_COMPLETED,
  CLEARTOAST_NOTIFICATIONS_REQUESTED,
  CLEARTOAST_NOTIFCATIONS_ABORTED,
  CLEARTOAST_NOTIFICATIONS_COMPLETED,
  CLEARTOAST_NOTIFICATIONS_FAILED,
  READ_NOTIFICATIONS_REQUESTED,
  READ_NOTIFCATIONS_ABORTED,
  READ_NOTIFICATIONS_COMPLETED,
  READ_NOTIFICATIONS_FAILED,
  OPENED_NOTIFICATION_REQUESTED,
  OPENED_NOTIFCATIONS_ABORTED,
  OPENED_NOTIFICATION_COMPLETED,
  OPENED_NOTIFICATION_FAILED,
} from '../../actions/notifications/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  markingasread: false,
  markedasread: false,
  markingasclicked: false,
  markedasclicked: false,
  clearingtoasts: false,
  clearedtoasts: false,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_NOTIFICATIONS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case LIST_NOTIFICATIONS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case LIST_NOTIFICATIONS_FAILED:
      return state.set('error', action.payload);

    case RESET_LIST_NOTIFICATIONS_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_LIST_NOTIFICATIONS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', { items: [] })
        .set('gotdata', true);

    case CLEARTOAST_NOTIFICATIONS_REQUESTED:
      return state
        .set('error', null)
        .set('clearedtoasts', false)
        .set('clearingtoasts', true);

    case CLEARTOAST_NOTIFCATIONS_ABORTED:
      return state
        .set('error', null)
        .set('clearedtoasts', false)
        .set('clearingtoasts', false);

    case CLEARTOAST_NOTIFICATIONS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('clearedtoasts', true)
        .set('data', { items: action.payload });

    case CLEARTOAST_NOTIFICATIONS_FAILED:
      return state.set('error', action.payload);

    case READ_NOTIFICATIONS_REQUESTED:
      return state
        .set('error', null)
        .set('markedasread', false)
        .set('markingasread', true);

    case READ_NOTIFCATIONS_ABORTED:
      return state
        .set('error', null)
        .set('markedasread', false)
        .set('markingasread', false);

    case READ_NOTIFICATIONS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('markedasread', true)
        .set('data', { items: action.payload });

    case READ_NOTIFICATIONS_FAILED:
      return state.set('error', action.payload);

    case OPENED_NOTIFICATION_REQUESTED:
      return state
        .set('error', null)
        .set('markedasclicked', false)
        .set('markingasclicked', true);

    case OPENED_NOTIFCATIONS_ABORTED:
      return state
        .set('error', null)
        .set('markedasclicked', false)
        .set('markingasclicked', false);

    case OPENED_NOTIFICATION_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('markedasclicked', true)
        .set('data', { items: action.payload });

    case OPENED_NOTIFICATION_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
